import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { PreferencesSettingsPage } from "src/pages/PreferencesSettingsPage";
import { settingsQueryOptions } from "src/queries/settings";

export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/settings/preferences",
)({
  component: PreferencesSettingsPage,
  ssr: true,
  loader: async ({ context }) => {
    return loaderHandler(async () => {
      await context.queryClient.query({
        ...settingsQueryOptions(),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
